import SolutionLayout, {
  type SolutionData,
} from "../../components/SolutionLayout";
import {
  BuildingIcon,
  CodeIcon,
  StopwatchIcon,
} from "../../components/Icons";

const data: SolutionData = {
  path: "/solutions/b2b",
  eyebrow: "Solution · B2B & wholesale",
  headline: "Support for business customers, one company at a time.",
  lede: "When several people from the same business write in, you want to see them together, answer the important ones first, and know what the account looks like in your own systems. ZopDesk does that with companies, SLA targets by priority, and the customer data lookup.",
  stats: [
    { value: "Companies", label: "Grouped by email domain", sub: "Everyone from one business together" },
    { value: "4", label: "Priorities with SLA targets", sub: "First reply and resolution, business hours" },
    { value: "Lookup", label: "Your account data", sub: "Fields and links from your own system" },
  ],
  painFix: [
    {
      pain: "Three people at the same customer email from three addresses, and each is handled as a stranger.",
      fix: "Give a company its email domain and everyone writing in from it joins the company. Open the company to see all of its people and their tickets.",
    },
    {
      pain: "Urgent requests from big accounts wait in the same queue as everything else.",
      fix: "Rules can set priority by sender, for example anyone from @bigcustomer.com, and SLA targets per priority show when each ticket's first reply and resolution are due. There are no breach alerts yet.",
    },
    {
      pain: "Agents look up the account tier, contract or account manager in another tool before they can answer.",
      fix: "Point the customer data lookup at an endpoint in your own system, and the fields and links it returns show on every ticket.",
    },
  ],
  highlights: [
    {
      Icon: BuildingIcon,
      title: "Companies",
      body: "Group people by email domain, or add them by hand. Personal providers like gmail.com can't be company domains.",
    },
    {
      Icon: StopwatchIcon,
      title: "SLA targets by priority",
      body: "First-reply and resolution targets for low, normal, high and urgent, counted in your business hours, with due-time markers on tickets.",
    },
    {
      Icon: CodeIcon,
      title: "Customer data lookup",
      body: "Your account data in the sidebar, fetched from your HTTPS endpoint with signed requests.",
    },
  ],
  relatedSolutions: [
    { to: "/solutions/dtc", label: "Direct-to-consumer" },
    { to: "/solutions/marketplaces", label: "Marketplaces" },
    { to: "/solutions/subscription", label: "Subscription" },
  ],
};

export default function SolutionB2b() {
  return <SolutionLayout data={data} />;
}
